import { useEffect, useState } from 'react'
import { getObjectsWithFilter } from '../../../api/apiClientCrud'
import { Button, Typography } from '@mui/material'

const ManageContract = ({ company }) => {
  const [contract, setContract] = useState(null)

  useEffect(() => {
    const fetchCustomer = async () => {
      getObjectsWithFilter('contracts', { company_id: company, status: 20 })
        .then((res) => {
          setContract(res.data.contracts[0])
        })
        .catch(() => {})
    }
    fetchCustomer()
  }, [])

  return (
    <>
      {contract !== null && contract !== undefined && (
        <>
          <Typography>{contract.contract_number}</Typography>
          <Button>Résililier</Button>
          <Button>Résililier</Button>
        </>
      )}
    </>
  )
}

export default ManageContract
